/**
 * A simple version of the `classnames` package, only supports strings as arguments.
 */
export default function cx(...args: unknown[]): string {
  let result = ''
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < args.length; i++) {
    const arg = args[i]
    if (typeof arg !== 'string') {
      continue
    }
    const trimmed = arg.trim()
    if (trimmed === '') {
      continue
    }

    if (result !== '') {
      result += ' ' + arg
    } else {
      result = arg
    }
  }
  return result
}
